export const SUBMISSION_PERIODS = ['Weekly', 'Monthly', 'Quarterly'];

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const FULL_MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

// Parse 'YYYY-MM-DD' into numeric parts without Date() (avoids TZ shifts).
function parts(iso) {
  const [y, m, d] = iso.split('-').map(Number);
  return { y, m: m - 1, d };
}

export function formatPeriodLabel(period, start, end) {
  const s = parts(start);
  const e = parts(end);
  if (period === 'Weekly') {
    // ISO weeks (Mon–Sun) can span month and year boundaries.
    if (s.y !== e.y) {
      return `Weekly · ${MONTHS[s.m]} ${s.d}, ${s.y} – ${MONTHS[e.m]} ${e.d}, ${e.y}`;
    }
    if (s.m !== e.m) {
      return `Weekly · ${MONTHS[s.m]} ${s.d} – ${MONTHS[e.m]} ${e.d}, ${e.y}`;
    }
    return `Weekly · ${MONTHS[s.m]} ${s.d}–${e.d}, ${e.y}`;
  }
  if (period === 'Monthly') {
    return `Monthly · ${FULL_MONTHS[s.m]} ${s.y}`;
  }
  if (period === 'Quarterly') {
    const q = Math.floor(s.m / 3) + 1;
    return `Quarterly · Q${q} ${s.y}`;
  }
  // Fallback for an unexpected cadence — show the start date rather than mislabel.
  return `${period} · ${MONTHS[s.m]} ${s.d}, ${s.y}`;
}
